import { ref, computed } from 'vue';
import { createChatDelivery } from '@/lib/chatDelivery';

export function useChatDelivery({ ticketId, ...options }) {
  const entries = ref([]);
  const delivery = createChatDelivery({ ...options, changed: value => { entries.value = value; } });
  const track = () => { void entries.value; };
  return {
    isSending: computed(() => { track(); return delivery.isSending(ticketId.value); }),
    deliveryStatus: computed(() => { track(); return delivery.status(ticketId.value); }),
    visibleConversations(messages) { track(); return delivery.visibleConversations(messages, ticketId.value); },
    reconcile: (messages, metadata) => delivery.reconcile(messages, metadata, ticketId.value),
    submit: content => delivery.submit(ticketId.value, content),
    retry: id => delivery.retry(ticketId.value, id),
    reset: delivery.reset,
    dispose: delivery.dispose,
  };
}
